import * as React from 'react';

function Cycling(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.833 11.5a4.167 4.167 0 110 8.333 4.167 4.167 0 010-8.333zm-11.666 0a4.167 4.167 0 110 8.333 4.167 4.167 0 010-8.333zm11.666 1.667a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm-11.666 0a2.5 2.5 0 100 5 2.5 2.5 0 000-5zM14.09 6.79l.06.08 1.341 2.012 2.764-.69a.833.833 0 01.982.513l.029.092a.833.833 0 01-.514.982l-.092.03-3.334.833a.834.834 0 01-.833-.263l-.062-.083-1.227-1.84-2.422 1.454 2.342 1.757a.834.834 0 01.332.725l-.014.105-.834 4.166a.834.834 0 01-1.648-.23l.013-.096.73-3.653L8.792 10.5a.834.834 0 01-.019-1.32l.09-.06 4.167-2.5a.833.833 0 011.06.17zM16.167 4a1.667 1.667 0 110 3.333 1.667 1.667 0 010-3.333z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Cycling;
